import {HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {Observable} from 'rxjs';
import {inject} from '@angular/core';
import {EnvironmentService} from '../services/environment.service';

export const baseInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<unknown>> => {
  const config = inject(EnvironmentService);

  if (!config.baseUrl) {
   return next(request);
  }

  const baseUrl = config.baseUrl.endsWith('/') ? config.baseUrl : `${config.baseUrl}/`;
  const relativeUrl = request.url.startsWith('/') ? request.url.slice(1) : request.url;
  const url = new URL(relativeUrl, baseUrl).toString();

  return next(request.clone({url}));
};
